import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import ErrorMessage from "../../../components/common/ErrorMessage";
import Modal from "../../../components/common/Modal";
import PageHeading from "../../../components/common/PageHeading";
import Button from "../../../components/form/Button";
import Input from "../../../components/form/Input";
import useSelectedAccount from "../../../hooks/useSelectedAccount";
import { useUpdateTemplateMutation } from "../../../redux/services/templates";

const TemplateRenameModal = ({
  templateId,
  templateName,
  onRequestClose,
}: {
  templateId: string;
  templateName: string;
  onRequestClose: () => void;
}) => {
  const [name, setName] = useState(templateName);
  const disabled = templateName === name || !name;

  const { selectedAccount } = useSelectedAccount();

  const [updateTemplateById, { isLoading, isSuccess, isError, error }] =
    useUpdateTemplateMutation();

  useEffect(() => {
    if (isSuccess) {
      toast.success("Template renamed successfully.");
      onRequestClose();
    }
  }, [isSuccess, onRequestClose]);

  const handleRename = async () => {
    if (!disabled) {
      try {
        await updateTemplateById({
          name,
          templateId,
          accountId: selectedAccount?.accountId,
        })
          .unwrap()
          .catch(() => {});
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <Modal
      isOpen={true}
      onRequestClose={onRequestClose}
      width={500}
    >
      <div className="p-6 space-y-4">
        <PageHeading heading="Rename Article Template Settings" />
        <Input
          label="Template name"
          value={name}
          maxLength={200}
          onChange={(e) => setName(e.target.value)}
        />

        {isError && error && (
          <div>
            <ErrorMessage
              name="templateName"
              className="flex"
              errorMessage={
                (error as any)?.data?.detail ??
                "Error updating. Please try again."
              }
            />
          </div>
        )}
        <Button
          type="submit"
          variant={disabled ? "disabled" : "primary"}
          loading={isLoading}
          className="min-w-24"
          onClick={handleRename}
        >
          Rename
        </Button>
        <Button
          type="button"
          variant="transparent"
          onClick={onRequestClose}
        >
          Cancel
        </Button>
      </div>
    </Modal>
  );
};

export default TemplateRenameModal;
